import { IPromise } from "angular";
import { IModalService } from "angular-ui-bootstrap";
import { IGroupDetailsSidebarComponentBindingsResolve } from "./group-details-sidebar.component";

export class GroupDetailsSidebarService {
  static $inject = ["$uibModal"];
  constructor(private $uibModal: IModalService) {}
  open(args: IGroupDetailsSidebarComponentBindingsResolve): IPromise<unknown> {
    return this.$uibModal.open({
      component: "groupDetailsSidebar",
      resolve: {
        filter: () => args.filter,
        config: () => args.config,
      },
      windowClass: "group-details-sidebar",
    }).result;
  }
}
